/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Drm_ProtectedInputs */

const en_conversion_error_drm_protected = /** @type {(inputs: Conversion_Error_Drm_ProtectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This book is copy-protected (DRM) and cannot be imported. A DRM-free copy will work.`)
};

const es_conversion_error_drm_protected = /** @type {(inputs: Conversion_Error_Drm_ProtectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este libro está protegido contra copia (DRM) y no se puede importar. Una copia sin DRM funcionará.`)
};

/**
* | output |
* | --- |
* | "This book is copy-protected (DRM) and cannot be imported. A DRM-free copy will work." |
*
* @param {Conversion_Error_Drm_ProtectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_drm_protected = /** @type {((inputs?: Conversion_Error_Drm_ProtectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Drm_ProtectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_drm_protected(inputs)
	return en_conversion_error_drm_protected(inputs)
});